module.exports = __webpack_public_path__ + "img/company_logo_emblem.f2f7f373.png";